export const GENERIC_MESSAGE =
    'We are unable to sign you into the platform at this time. Please try again later, or contact your System Administrator for assistance.';

export const DB_FAILURE_ERROR_MESSAGE =
    'An issue has occurred that is preventing access to the platform. We’re working to resolve the issue as soon as possible.';

export const GENERIC_MESSAGE_KEYS = ['username', 'password', 'company', 'partner'];

export const RESET_PASSWORD = 'Reset Password';
export const PASSWORD_PLACEHOLDER = '******';

export const ERROR_CODES = {
    DB_ERROR: '1004',
    LOGIN_ATTEMPT: '1048',
    LOGIN_ATTEMPT_EXCEEDED: '1049',
};
